<template>
  <cTable ref="table" :fields="fields" :header="header" :methods="methods" :modals="modals" :config="config">
    <!-- <template #TEST="{field,row}">
        <Button>{{row[field.key]}}</Button>
      </template> -->
    <template #DETAILS="{ visible, params }">
      <Tracker v-if="visible" :statusId="params.row.airway_number"></Tracker>
    </template>
    <template #PREVIEW="{ params, visible }">
      <img :visible="visible" style="width: 100%;" :src="params.src">
    </template>
  </cTable>
</template>

<script>
import {
  getOrderDetails,
  getOrderStatus,
  getReturn,
  returnOrderPlan,
  returnOpte,
} from "@/api/order/list";
import Tracker from "@/base/order_tracker";
import { getCompanies } from "@/api/user/client";
import { getAllClient } from "@/api/user/client";
import { proxyErr, pushProxy, saveProxy } from "@/api/order/proxy";
import { getSelectType } from "@/api/public";
import {
  planList,
  planStatus,
  paymentList
} from "../order-template/localData.js";
import cTable from "@/base/common/index";
export default {
  name: "orderReturn",
  components: {
    cTable,
    Tracker
  },
  mounted() { },
  methods: {
    preview(src) {
      this.current = 0
      this.$refs['table'].getModal('preview').open({ src })
    },
  },
  data() {
    return {
      methods: {
        list: getReturn,
        returnOrderPlan,
        returnOpte,
        getAllClient,
        getSelectType,
        // getDetails
      },
      config: {
        height: 630
      },
      modals: {

        preview: {
          config: {
            title: this.$tz('显示')
          },
          contentSlot: 'PREVIEW',
          footer: {
            show: false
          }
        },
        planReturn: {
          methods: {
            ok({ row, close }) {
              row["equipment"] = "OMS";
              this.$page
                .handleRequestMethods("returnOrderPlan", row, true)
                .then(res => {
                  this.$page.getList();
                  this.close();
                });
            }
          },
          config: {
            rules: {
              airway_number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "bulr"
                }
              ],
              // plan: [
              //   {
              //     required: true,
              //     message: "plan cannot be empty",
              //     trigger: "blur"
              //   }
              // ],
              payment_type: [
                {
                  required: true,
                  message: "payment_type cannot be empty",
                  trigger: "blur",
                  type: "number"
                }
              ],
              remark: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "bulr"
                }
              ]
            },
            formBind: {
              labelWidth: 100
            },
            title: this.$t("planReturn") + this.$t("operation"),
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          grid: [
            { airway_number: 24 },
            { plan: 24 },
            { payment_type: 24 },
            { remark: 24 }
          ],
          fields: [
            {
              key: "airway_number",
              name: () => this.$t("order_number"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("order_number");
              },
              bind: {
                type: 'textarea',
                rows: 3,
              }
            },
            {
              key: "plan",
              name: () => this.$t("plan1"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("plan1");
              },
              options: planList,
              config: { label: ({ row }) => this.$t(row.label) }
            },
            {
              key: "payment_type",
              name: () => this.$t("order_type"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("order_type");
              },
              show: ({ row }) => row.plan == "sendExpress",
              options: [],
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods(
                      "getSelectType",
                      "RETURN_PAYMENT_TYPE"
                    )
                  ).payload["RETURN_PAYMENT_TYPE"];
                  this.$forceUpdate();
                }
              }
            },
            {
              key: "remark",
              name: () => this.$t("order_desc"),
              component: "Select",
              placeholder() {
                return this.$t("enter") + this.$t("order_desc");
              },
              options: [],
              methods: {
                async list({ field }) {
                  field.options = await this.$sel.getData('RETURN_REMARK');
                  this.$forceUpdate();
                }
              }
            }
          ]
        },
        show: {
          contentSlot: "DETAILS",
          config: {
            modalBind: {
              draggable: true,
              transfer: true,
              width: 600
            }
          },
          footer: { show: () => false }
        },
        operation: {
          methods: {
            ok({ row, close }) {
              let formData = new FormData();
              formData.append("file", row.file);
              formData.append("tracking_number", row.tracking_number);
              let data = {
                formData: formData,
                id: row.id
              };
              this.$page
                .handleRequestMethods("returnOpte", data, true)
                .then(res => {
                  this.$page.getList();
                  this.close();
                });
            }
          },
          config: {
            rules: {
              tracking_number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "bulr"
                }
              ]
            },
            formBind: {
              labelWidth: 100
            },
            title: this.$t("operation"),
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          grid: [{ tracking_number: 24 }, { payment_code: 24 }],
          fields: [
            {
              key: "tracking_number",
              name: () => this.$t("tracking_number"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("tracking_number");
              }
            },
            {
              key: "payment_code",
              name: () => this.$t("paymentCode"),
              component: "Upload-img",
              bind: {
                multiple: false
              },
              methods: {
                beforeUpload({ row, file }) {
                  const reader = new FileReader();
                  reader.readAsDataURL(file);
                  reader.onload = function (e) {
                    // 文件base64
                    const fileBase64 = this.result;
                    row.payment_code = fileBase64;
                    row.file = file;
                  };
                  return false;
                }
              }
            }
          ]
        }
      },
      header: {
        searchs: [
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              }
              // "on-change"({ searchForm }) {
              //   searchForm.startTime = searchForm.startTime
              //     ? this.$page.format.timeFormat(searchForm.startTime)
              //     : "";
              // }
            }
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              }
              // "on-change"({ searchForm }) {
              //   let time = this.$page.format.timeFormat(searchForm.endTime);
              //   if (time.slice(-8) === "00:00:00") {
              //     time = time.split(" ")[0] + " " + "23:59:59";
              //     searchForm["endTime"] = time;
              //   }
              // }
            }
          },
          {
            key: "clientId",
            component: "Select",
            bind: {
              style: "width:175px"
            },
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            options: [],
            config: { label: "account", value: "id" },
            methods: {
              async list({ field }) {
                field.options = (
                  await this.$page.handleRequestMethods("getAllClient")
                ).payload.rows;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "ownership",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("ownership");
            },
            clearable: true,
            options: [],
            config: { label: "title", value: "id" },
            bind: {
              style: "width:150px"
            },
            methods: {
              async list({ field, searchForm }) {
                let res = (await getCompanies()).data.payload;
                field.options = res;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "is_return",
            component: "Select",
            placeholder() {
              return this.$t("WhetherAlreadyOperation");
            },
            clearable: true,
            options: [
              { label: this.$t('YES'), value: 'YES' },
              { label: this.$t('NO'), value: 'NO' }
            ],
            bind: {
              style: "width:150px"
            },
          },
          {
            key: "remark",
            component: "Select",
            bind: {
              style: "width:175px"
            },
            placeholder() {
              return this.$t("select") + this.$t("order_desc");
            },
            options: [],
            methods: {
              async list({ field }) {
                field.options = await this.$sel.getData('RETURN_REMARK');
                this.$forceUpdate();
              }
            }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1
              // autosize: { minRows: 2, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("planReturn") + this.$t("operation"),
              type: "planReturn",
              fnName: "planReturnFun",
              bind: {
                type: "warning"
              },
              id: 639
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            },

          ],
          methods: {

            export() {
              this.exportExc();
            },
            planReturnFun() {
              this.getModal("planReturn").open();
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60
        },
        {
          name: () => this.$t("order_number"),
          key: "airway_number",
          component: "Button",
          copy: true,
          align: "center",
          bind: {
            type: "primary",
            size: "small"
          },
          showOverflow: false,
          width: 160,
          header: {
            copy: true
          },
          methods: {
            click({ row }) {
              this.$page.getModal("show").setTitle(row.airway_number);
              this.$page.getModal("show").open({ row });
            }
          }
        },
        {
          name: () => this.$t("Update time"),
          key: "plan_time",
          align: "center",
          minWidth: 170,
          methods: {
            render({ value }) {
              return ~~value ? this.format.timeFormat(value * 1000) : "-";
            }
          }
        },
        {
          name: () => this.$t("plan1"),
          key: "plan",
          align: "center",
          minWidth: 120,
          methods: {
            render: ({ value }) =>
              planStatus[value] ? this.$t(planStatus[value]) : " "
          }
        },
        {
          name: () => this.$t("order_type"),
          key: "payment_type",
          align: "center",
          minWidth: 120,
          methods: {
            render: ({ value }) =>
              paymentList[value] ? this.$t(paymentList[value]) : " "
          }
        },
        {
          name: () => this.$t("plan_location"),
          key: "location",
          align: "center",
          minWidth: 95
        },
        {
          name: () => this.$t("clientName"),
          key: "client_name",
          align: "center",
          minWidth: 95
        },
        {
          name: () => this.$t("ownership"),
          key: "ownership_name",
          align: "center",
          minWidth: 140
        },
        {
          name: () => this.$t("status_operator"),
          key: "operator_name",
          align: "center",
          minWidth: 95
        },
        {
          name: () => this.$t("service"),
          key: "customer_service_name",
          align: "center",
          minWidth: 95
        },
        {
          name: () => this.$t("CustomerNote"),
          key: "plan_remark",
          align: "center",
          minWidth: 110
        },

        {
          name: () => this.$t("plan_remark"),
          key: "remark",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("equipment"),
          key: "equipment",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("tracking_number"),
          key: "tracking_number",
          align: "center",
          minWidth: 130
        },
        {
          name: this.$tz("收款码"),
          key: "pay_link",
          width: 120,
          render: (h, p) => {
            return h('Button', {
              attrs: {
                type: 'primary',
                size: 'small',
                disabled: !p.row[p.field.key]
              },
              on: {
                click: () => {
                  this.preview(this.$globalUrl + p.row[p.field.key])
                }
              }
            }, this.$tz('显示'))
          }
        },
        {
          type: "btns",
          width: 100,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("operation"),
              type: "operation",
              fnName: "operationFun",
              bind: {
                type: "warning"
              },
              id: 1339
            }
          ],

          methods: {
            operationFun({ row }) {
              this.getModal("operation").open({
                id: row.airway_number,
                tracking_number: row.tracking_number,
                payment_code: row.pay_link
              });
            }
          }
        }
      ]
    };
  }
};
</script>
